import angular from 'angular'
import languageFactory from './language.factory'

let languageModule = angular.module('language.factory', []).
  factory('LanguageFactory', languageFactory).name

export default languageModule



// WEBPACK FOOTER //
// ./client/app/common/factories/languageFactory/language.js